const MobilePlaylist = {
  $playerList: null,
  $playerInfo: null,
  $dataContainer: null,
  paginationContainerSelector: null,
  requests: [],

  init: function(playerListSelector, playerInfoSelector, dataContainerSelector, paginationContainerSelector){
    this.$playerList = $(playerListSelector);
    this.$playerInfo = $(playerInfoSelector);
    this.$dataContainer = $(dataContainerSelector);
    this.paginationContainerSelector = paginationContainerSelector;
    this.body = document.querySelector('body');
    this.bindTogglePlaylist();
    this.bindScrollPlaylist();
  },

  bindTogglePlaylist: function(){
    this.$playerInfo.click(function(){
      var arrow = this.$playerInfo.find('.arrow');
      if (arrow.hasClass('arrow-down')) {
        arrow.removeClass('arrow-down').addClass('arrow-up');

        this.body.classList.add('l-mobile__overflow-hidden');
      } else {
        arrow.removeClass('arrow-up').addClass('arrow-down');

        this.body.classList.remove('l-mobile__overflow-hidden');
      }
      this.$playerList.toggle();
      this.$dataContainer.toggle();
      $('#footer').toggle();
    }.bind(this));
  },

  bindScrollPlaylist: function(){
    $(window).on('scroll', function(){
      if(this.$playerList.filter(':visible').length > 0){
        if(this.getWindowScrollTop() > this.getOrdinate()){
          this.makeAjaxRequest();
        }
      }
    }.bind(this));
  },

  makeAjaxRequest: function(){
    var url = $(this.paginationContainerSelector).text();
    if(url !== "" && this.requests.indexOf(url) < 0) {
      this.requests.push(url);
      $.get(url);
    }
  },

  getOrdinate: function(){
    return $(document).height() - $(window).height() - 10;
  },

  getWindowScrollTop: function(){
    return $(window).scrollTop();
  },

  scrollToRightBelowHeader() {
    const sectionTopContainer = document.querySelector('#top');
    // Add 1px so that player container always sticky when open capsule and hides the header
    window.scroll(0, sectionTopContainer.offsetHeight + 1);
  }
};

export default MobilePlaylist;
